import Form from "@/shared/form/form";
import { ReactNode, useEffect } from "react";
import { FieldsType } from "../../../model/types";
import { useSaveNotificationTemplate } from "../../../model/use-save-notification-template";
import { TemplateFormView } from "./template-form-view";
import { useInitialValues } from "../../../model/initial-values-provider/initial-values-context";

export type TemplateFormProps = {
  afterSubmit?: () => void;
  id?: string;
  partOf?: boolean;
  forDynamicProcess?: boolean;
  propertyTree?: ReactNode;
  name?: string;
};

export function TemplateForm({
  partOf,
  forDynamicProcess,
  propertyTree,
  afterSubmit,
  id,
  ...formProps
}: TemplateFormProps) {
  const { loading, save } = useSaveNotificationTemplate({ id, afterSubmit });

  const [form] = Form.useForm<FieldsType>();

  const initialValues = useInitialValues();

  useEffect(() => {
    form.validateFields();
  }, [form]);

  return (
    <TemplateFormView
      partOf={partOf}
      forDynamicProcess={forDynamicProcess}
      propertyTree={propertyTree}
      form={form}
      initialValues={initialValues ?? undefined}
      layout="vertical"
      disabled={loading}
      onFinish={!partOf ? save : undefined}
      {...formProps}
    />
  );
}
